import { all, takeLatest, call, put } from 'redux-saga/effects';
import { toast } from 'sonner';
import { t } from 'copy/t';
import { navigate } from 'navigation';
import {
  SIGN_IN_REQUEST,
  SIGN_IN_SUCCESS,
  SIGN_IN_FAILURE,
  RESEND_VERIFICATION_REQUEST,
  RESEND_VERIFICATION_SUCCESS, RESEND_VERIFICATION_FAILURE
} from './constants';
import { resendVerificationEmail } from 'utils/api';
import { resetForm, signInFailure, signInSuccess, resendVerificationEmailSuccess, resendVerificationEmailFailure } from "./actions";
import { apiSaga } from 'sagas';
import { postSession } from 'utils/api';
import { setItem } from 'utils/localStorage';

import { setAuthToken } from 'containers/App/actions';
import { getSessionFlow } from 'containers/App/sagas';
// import { startSubmit, stopSubmit } from 'redux-form';

export function* signInFlow({ payload }) {
  // yield put(startSubmit('signIn'));
  yield put(resetForm(false));
  yield* apiSaga(postSession, [payload], signInSuccess, signInFailure);
  // yield put(stopSubmit('signIn'))
}

export function* authenticate({ payload }) {
  yield all([
    put(setAuthToken(payload.authentication_token)),
    call(setItem, 'authToken', payload.authentication_token),
    call(navigate, '/'),
  ]);

  yield* getSessionFlow();
}

export function* putLoginError({payload}) {
  if (payload.message !== "Password is no longer valid")  {
  if (payload.not_confirmed) {
    toast.warning(t('toast.signIn.verifyEmail'), { duration: 10000 });
  } else {
    toast.error(t('toast.signIn.invalidCredentials'), { action: { label: t('toast.signIn.resetPassword'), onClick: () => window.location.href = '/forgot-password' } });
  }
  yield put(resetForm(true));
  }
  else yield call(navigate, `/forgot-password?update_password_token=${payload.token}`);
}

export function* putResendVerificationRequest({ payload }) {
  yield* apiSaga(resendVerificationEmail, [payload], resendVerificationEmailSuccess, resendVerificationEmailFailure);
}

export function* putResendVerificationSuccess() {
  toast.success(t('toast.signIn.verificationSent'));
}

export function* putResendVerificationFailure() {
  toast.error(t('toast.signIn.verificationFailed'));
}

export default function* watchSignIn() {
  yield all([
    takeLatest(SIGN_IN_REQUEST, signInFlow),
    takeLatest(SIGN_IN_SUCCESS, authenticate),
    takeLatest(SIGN_IN_FAILURE, putLoginError),
    takeLatest(RESEND_VERIFICATION_REQUEST, putResendVerificationRequest),
    takeLatest(RESEND_VERIFICATION_SUCCESS, putResendVerificationSuccess),
    takeLatest(RESEND_VERIFICATION_FAILURE, putResendVerificationFailure),
  ]);
}
